module.exports = __webpack_public_path__ + "img/work2.23ddb651.png";